import React from "react";
import "./ActivityLogCard.scss";
import aiChatlogo from "../../../../../../assets/Images/aiChatlogo.png";
import {
  ACTIVITY_LOG_TABLE_HEADERS,
  DEFAULT_ACTIVITY_LOGS,
} from "../../../../../../util/constants";

// Displays order activity logs in a table format within the AI chat
export const ActivityLogCard = ({ message }) => {
  const logs = message?.activityLogs || DEFAULT_ACTIVITY_LOGS;

  return (
    <div className={`order-chat-bubble ${message?.role || "ai"}`}>
      <div className="activity-log-card">
        {/* Header */}
        <div className="activity-log-card__header">
          <div className="activity-log-card__logo">
            <img
              src={aiChatlogo}
              alt="Axon AI"
              aria-hidden="true"
              className="activity-log-card__logo-img"
            />
          </div>
          <div className="activity-log-card__title-info">
            <span className="activity-log-card__title">
              {message?.header?.title || "Axon AI"}
            </span>
            <span className="activity-log-card__timestamp">Just now</span>
          </div>
        </div>

        {/* Body */}
        <div className="activity-log-card__body">
          <p className="activity-log-card__intro">
            Here are the activity logs for this order in ascending order.
          </p>

          {/* Table */}
          <div className="activity-log-card__table-wrapper">
            <table className="activity-log-card__table">
              <thead>
                <tr>
                  {ACTIVITY_LOG_TABLE_HEADERS.map((header) => (
                    <th key={header}>{header}</th>
                  ))}
                </tr>
              </thead>
              <tbody>
                {logs.map((log, idx) => {
                  // Convert updatedOn to local time and format it
                  const formatDateTime = (raw) => {
                    if (!raw) return { date: "--", time: "--" };

                    try {
                      const dateObj = new Date(raw);
                      if (isNaN(dateObj.getTime()))
                        return { date: "--", time: "--" };

                      // Format date as "Dec 15, 2025"
                      const dateFormatted = dateObj.toLocaleDateString(
                        "en-US",
                        {
                          month: "short",
                          day: "2-digit",
                          year: "numeric",
                        },
                      );

                      // Format time as "05:00 AM"
                      const timeFormatted = dateObj.toLocaleTimeString(
                        "en-US",
                        {
                          hour: "2-digit",
                          minute: "2-digit",
                          hour12: true,
                        },
                      );

                      return { date: dateFormatted, time: timeFormatted };
                    } catch {
                      return { date: "--", time: "--" };
                    }
                  };

                  const { date, time } = formatDateTime(log.updatedOn);

                  return (
                    <tr key={idx}>
                      <td>{log.activityType}</td>
                      <td className="activity-log-card__cell-details">
                        {log.activityDetails}
                      </td>
                      <td>{log.newValue}</td>
                      <td>{log.updatedBy}</td>
                      <td>{log.agentType}</td>
                      {/* <td>
                        <span
                          className={`activity-log-card__role-badge ${
                            log.role === "Preparer"
                              ? "activity-log-card__role-badge--preparer"
                              : log.role === "Reviewer"
                                ? "activity-log-card__role-badge--reviewer"
                                : ""
                          }`}
                        >
                          {log.role}
                        </span>
                      </td> */}
                      <td>{log.oldValue || "--"}</td>
                      <td className="activity-log-card__cell-datetime">
                        <span className="activity-log-card__date">{date}</span>
                        {time ? (
                          <span className="activity-log-card__time">
                            {time}
                          </span>
                        ) : null}
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>

          {/* Footer question */}
          <p className="activity-log-card__footer">
            {/* Do you need more info about any logs mentioned above?  */}
          </p>
        </div>
      </div>
    </div>
  );
};
